import { Injectable } from '@angular/core';
import { ProcessMonitor } from './process-monitor';

@Injectable({ providedIn: 'root' })
export class GaLoadingProcessService {
  public readonly process: ProcessMonitor = new ProcessMonitor();
}
